import { Navigate } from 'react-router-dom';
import { useSaasSession } from '../../saas/SessionContext';

export default function ReportPermissionRoute({ permission, children }) {
  const { membership } = useSaasSession();
  if (membership?.role === 'owner') return children;
  const permissions = membership?.permissions || {};
  if (permissions.reports === true && permissions[permission] === true) return children;
  return <Navigate to="/" replace />;
}
